module.exports = __webpack_public_path__ + "img/icon_promo.bac17ef.webp";